import HttpFactory from '~/repository/factory'
import type {
  PrevidenciaFundosQuery,
  PrevidenciaFundosResponse,
} from '~/types/study'

class PrevidenciaModule extends HttpFactory {
  private RESOURCE = '/study/previdencia'

  async getFundos(params?: PrevidenciaFundosQuery): Promise<PrevidenciaFundosResponse> {
    return this.get<PrevidenciaFundosResponse>(`${this.RESOURCE}/fundos`, { query: params })
  }
}

export default PrevidenciaModule
